import { rankingData } from '@/mocks/home';

const trendIcons: Record<string, string> = {
  up: 'ri-arrow-up-line',
  down: 'ri-arrow-down-line',
  new: 'ri-flashlight-line',
};

const trendColors: Record<string, string> = {
  up: 'text-primary-500',
  down: 'text-secondary-500',
  new: 'text-accent-500',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 bg-primary-100/80 text-primary-700 text-xs font-semibold rounded-full mb-3">
            实时热度
          </span>
          <h2 className="text-2xl md:text-4xl font-black text-foreground-950">
            热门榜单
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            基于播放量和讨论热度的实时排名，发现全网最火内容
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-100 rounded-2xl border border-background-200/60 overflow-hidden">
            {rankingData.map((item, i) => (
              <div
                key={i}
                className={`flex items-center gap-4 px-5 md:px-8 py-4 md:py-5 ${
                  i < rankingData.length - 1
                    ? 'border-b border-background-200/60'
                    : ''
                } hover:bg-primary-50/50 transition-colors duration-150`}
              >
                <div className="flex items-center gap-3 min-w-0 flex-1">
                  <span
                    className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-extrabold shrink-0 ${
                      i === 0
                        ? 'bg-primary-500 text-background-50'
                        : i === 1
                        ? 'bg-primary-300 text-primary-800'
                        : i === 2
                        ? 'bg-primary-200 text-primary-700'
                        : 'bg-background-200 text-foreground-500'
                    }`}
                  >
                    {item.rank}
                  </span>
                  <div className="min-w-0">
                    <h3 className="text-sm md:text-base font-bold text-foreground-900 truncate">
                      {item.title}
                    </h3>
                    <span className="text-xs text-foreground-500">
                      {item.category}
                    </span>
                  </div>
                </div>

                <div className="flex items-center gap-3 shrink-0">
                  <span className={`flex items-center gap-1 text-xs font-semibold ${trendColors[item.trend]}`}>
                    <i className={`${trendIcons[item.trend]} text-xs`}></i>
                  </span>
                  <span className="text-sm font-bold text-foreground-700 min-w-[60px] text-right">
                    {item.hot}
                    <span className="text-xs font-normal text-foreground-400 ml-0.5">播放</span>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}